import { EntityState } from '@reduxjs/toolkit';
import { UserAdapter, UserState } from '@store/user/user.slice';

export const UserSelector = UserAdapter.getSelectors(
  (state) => state as EntityState<UserState>,
);
